import { postSlackMessage } from '~/utils/slackHelpers';

const SLACK_CHANNEL = 'custom-offer-alerts';

type ManualV2TrackingAlertParams = {
  agentEmail: string;
  orderId: string;
};

export function buildManualV2TrackingMessage({ agentEmail, orderId }: ManualV2TrackingAlertParams): string {
  const env = window.configs?.APP_ENV || 'unknown';
  const orderLink = `${window.location.origin}/purchases/${orderId}`;

  return [
    `*Manual custom offer confirmed*`,
    `• *Environment:* ${env}`,
    `• *Agent:* ${agentEmail}`,
    `• *Order:* <${orderLink}|${orderId}>`,
  ].join('\n');
}

export async function sendManualV2TrackingAlert(params: ManualV2TrackingAlertParams): Promise<void> {
  try {
    const message = buildManualV2TrackingMessage(params);
    await postSlackMessage(SLACK_CHANNEL, message);
  } catch (error) {
    console.warn('Failed to send manual v2 tracking alert:', error);
  }
}
